module.exports = __webpack_public_path__ + "img/hr-green-croton-03.42888984.png";